import React from 'react'
import { LuCheck } from 'react-icons/lu';

const StepIndicator = ({ current }) => {

    const WIZARD_STEPS = ["Items", "Quotation", "Parties", "Terms", "Review"];
    return (
    <div className="mb-5">
      <div className="sm:hidden">
        <div className="flex items-center justify-between text-[11px] font-medium">
          <span className="text-slate-400">
            Step {current} of {WIZARD_STEPS.length}
          </span>
          <span className="text-slate-700">{WIZARD_STEPS[current - 1]}</span>
        </div>
        <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
          <div
            className="h-full rounded-full bg-brand-gradient transition-all duration-300"
            style={{ width: `${(current / WIZARD_STEPS.length) * 100}%` }}
          />
        </div>
      </div>
 
      {/* Desktop: full step rail */}
      <ol className="hidden items-center sm:flex">
        {WIZARD_STEPS.map((label, i) => {
          const step = i + 1;
          const state = step < current ? "done" : step === current ? "active" : "todo";
          return (
            <li key={label} className="flex flex-1 items-center last:flex-none">
              <div className="flex items-center gap-2">
                <div
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold transition-colors ${
                    state === "done"
                      ? "bg-brand-500 text-white"
                      : state === "active"
                        ? "bg-brand-50 text-brand-700 ring-2 ring-brand-500"
                        : "bg-slate-100 text-slate-400"
                  }`}
                >
                  {state === "done" ? <LuCheck size={12} /> : step}
                </div>
                <span className={`whitespace-nowrap text-[12px] font-medium ${state === "todo" ? "text-slate-400" : "text-slate-700"}`}>
                  {label}
                </span>
              </div>
              {step !== WIZARD_STEPS.length && (
                <div className={`mx-2.5 h-px flex-1 ${state === "done" ? "bg-brand-400" : "bg-slate-200"}`} />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export default StepIndicator